export default "/wp-content/themes/onnit/script/cart/dist/abFocusShotMultiMobileOverride-195c3d44.png";